import { useMemo } from "react";
import { Group } from "../types/Group";
import Section from "../types/Section";

export interface FormTreeEntry {
  groupIdx?: number;
  group?: Group;
  children: { section: Section; idx: number }[];
}

interface Options {
  ignoreAdministrative?: boolean;
}

function useFormTree(
  schema: Section[],
  groups: Group[],
  options: Options = {}
) {
  const tree = useMemo(() => {
    const indexedSchema = schema.map((section, idx) => ({ section, idx }));
    const normalizedGroups: FormTreeEntry[] = [];
    const firstGroup = groups.length > 0 ? groups[0].start : schema.length;
    normalizedGroups.push({
      children: indexedSchema.filter((_, idx) => idx < firstGroup),
    });
    groups.forEach((group, idx) => {
      normalizedGroups.push({
        groupIdx: idx,
        group,
        children: indexedSchema.filter(
          (_, idx) => idx >= group.start && idx < group.end
        ),
      });
      const nextGroup =
        idx + 1 < groups.length ? groups[idx + 1].start : schema.length;
      normalizedGroups.push({
        children: indexedSchema.filter(
          (_, idx) => idx >= group.end && idx < nextGroup
        ),
      });
    });

    if (!options.ignoreAdministrative) return normalizedGroups;

    normalizedGroups.forEach((entry) => {
      entry.children = entry.children.filter(
        (child) => !(child.section as any).administrative
      );
    });
    return normalizedGroups.filter((entry) => entry.children.length > 0);
  }, [schema, groups]);
  return tree;
}

export default useFormTree;
